<h2 class="mat-h2">KAM leaderboard</h2>
<table mat-table [dataSource]="kamLeaderboardDataSource" matSort class="resize" class="table-fixed">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Territory</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>
  <ng-container matColumnDef="total">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total # packs</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.total) }}</td>
  </ng-container>
  <ng-container matColumnDef="delta4Month">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="momentumShortDesc">Δ 4 month</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.delta4Month) }}<span *ngIf="element.delta4Month">%</span></td>
  </ng-container>
  <ng-container matColumnDef="deltaPY">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="momentumLongDesc">Δ PY</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.deltaPY) }}<span *ngIf="element.deltaPY">%</span></td>
  </ng-container>
  <ng-container matColumnDef="totalSalesInEuro">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total sales €</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.totalSalesInEuro) }}</td>
  </ng-container>

  <ng-container matColumnDef="utilisationPharmascope">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total # patients</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.utilisationPharmascope) }}</td>
  </ng-container>

  <ng-container *ngFor="let competitor of competitors" matColumnDef="{{ competitor.key }}">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ competitor.name }} # patients</th>
    <td mat-cell *matCellDef="let element">{{ printData(element[competitor.key]) }}</td>
  </ng-container>

  <!-- <ng-container matColumnDef="budget">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Budget</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.budget) }}</td>
  </ng-container> -->

  <ng-container matColumnDef="patientPotential">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ getHeader('c_proj_patient_potential1') }}</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.patientPotential) }}</td>
  </ng-container>
  <ng-container matColumnDef="patientUtilisation">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ getHeader('patient_utilisation1') }}</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.patientUtilisation) }}</td>
  </ng-container>

  <ng-container matColumnDef="percentage">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>%</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.percentage) }}<span *ngIf="element.percentage">%</span></td>
  </ng-container>
  <ng-container matColumnDef="accountProfiles">
    <th mat-header-cell *matHeaderCellDef mat-sort-header># account profiles</th>
    <td mat-cell *matCellDef="let element">{{ printData(element.accountProfiles) }}</td>
  </ng-container>

  <!-- <ng-container matColumnDef="lastUpdate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last KAM update</th>
    <td mat-cell *matCellDef="let element">{{ element.lastUpdate.toLocaleDateString() }}</td>
  </ng-container> -->

  <tr mat-header-row *matHeaderRowDef="kamLeaderboardDisplayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: kamLeaderboardDisplayedColumns;" [class]="{ highlight: row.name === 'National average'}"></tr>
</table>
